module.exports = __webpack_public_path__ + "static/media/Fourth.e4e7e548.png";